export async function sleep(ms): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/app/utils/sleep.ts